import session from '../../app/session'

export const deletePermission = (row) => {
  return (!!row && !!row.id) ? session.hasAdminPermission() : false;
};
